import './js/mobile-menu'
import './js/anchor-scroll'
import './js/to-top-btn'
import './js/slick'
import './js/max-height'
import './js/modal'
import './js/franshise'
import './js/buy-now'
import './js/nutrition'



